import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './AGIndustries.css';
import emailjs from '@emailjs/browser';


const inputStyle = {
  width: '100%',
  background: 'transparent',
  border: 'none',
  borderBottom: '1px solid rgba(255,255,255,0.6)',
  color: '#fff',
  fontFamily: 'Georgia, serif',
  fontSize: '14px',
  letterSpacing: '0.1em',
  padding: '10px 8px',
  outline: 'none',
  borderRadius: '4px',
  backdropFilter: 'blur(6px)',
  textShadow: '0 1px 4px rgba(0,0,0,0.6)',
  textTransform: 'none',
};

const labelStyle = {
  fontFamily: 'Georgia, serif',
  fontSize: '12px',
  letterSpacing: '0.2em',
  color: '#fff',
  display: 'block',
  marginBottom: '6px',
  textTransform: 'none',
  textShadow: '0 1px 6px rgba(0,0,0,0.8)',
  fontWeight: '500',
};

const fieldWrap = {
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
};

const Registrate = () => {
  const navigate = useNavigate();
  const [scrolled, setScrolled] = useState(false);
  const [form, setForm] = useState({
    nombre: '', apellidos: '', ultimaCompetencia: '',
    categoria: '', aval: null, curriculum: null,
    documentacion: null, conocimiento: '', estado: '', edad: '',
    acepta: false,
  });
  const [enviado, setEnviado] = useState(false);

  // --- CORRECCIÓN: Scroll al inicio al cargar y manejo de Header ---
  useEffect(() => {
    window.scrollTo(0, 0); // Esto hace que suba al inicio siempre

    const handleScroll = () => {
      setScrolled(window.scrollY > 80);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleChange = e => {
    const { name, value, type, checked, files } = e.target;
    let formattedValue = value;

    if (name === 'edad') {
    if (value === "") {
    setForm(f => ({ ...f, [name]: "" }));
    return;
    }
    const numValue = parseInt(value, 10);
    if (numValue < 0) formattedValue = Math.abs(numValue).toString();
    if (numValue > 25) {
    alert('La edad máxima permitida es de 25 años.');
    return;
    }
  }

    const isText = type === 'text' || type === 'textarea' || e.target.tagName === 'TEXTAREA';
    if (isText && typeof value === 'string' && value.length > 0) {
     formattedValue = value.charAt(0).toUpperCase() + value.slice(1);
    }

    setForm(f => ({
      ...f,
      [name]: type === 'checkbox' ? checked : type === 'file' ? files[0] : formattedValue,
    }));
  };

const handleSubmit = async () => {
  if (!form.acepta) {
    alert('Debes aceptar el reglamento para continuar.');
    return;
  }

  const archivosFaltantes = [];
  if (!form.curriculum) archivosFaltantes.push('Currículum');
  if (!form.aval) archivosFaltantes.push('Carta de Recomendación');
  if (!form.documentacion) archivosFaltantes.push('Documentación');

  if (archivosFaltantes.length > 0) {
    alert(`Por favor adjunta los siguientes archivos:\n\n${archivosFaltantes.join('\n')}`);
    return;
  }
  try {
    await emailjs.send(
      'service_ylmhlh3',
      'template_ax7kabj',
      {
        nombre: form.nombre,
        apellidos: form.apellidos,
        categoria: form.categoria,
        ultimaCompetencia: form.ultimaCompetencia,
        estado: form.estado,
        edad: form.edad,
        conocimiento: form.conocimiento,
      },
      'eKtUZ0SOujh9EuJQC'
    );
    setEnviado(true);
  } catch (error) {
    console.error(error);
    alert('Hubo un error al enviar. Intenta de nuevo.');
  }
};

  return (
    <div className="sx-wrapper">
      <div className="sx-video-bg">
        <video autoPlay muted loop playsInline className="sx-video">
          <source src="/Vino1.mp4" type="video/mp4" />
        </video>
        <div className="sx-video-overlay" />
      </div>
<header className={`sx-header ${scrolled ? 'scrolled' : ''}`}
  style={{
    alignItems: 'flex-start',
    paddingTop: '13px',
  }}
>
 <button
  onClick={() => navigate('/')}
  className="sx-back-btn"
  style={{
    background: 'none', border: 'none', color: '#fff',
    cursor: 'pointer', fontSize: '22px', opacity: 0.75,
    transition: 'opacity 0.3s ease',padding: '6px',
    marginLeft: '4',marginTop: '1px', display: 'flex',
    alignItems: 'center', justifyContent: 'center'
  }}
  onMouseEnter={e => e.currentTarget.style.opacity = 1}
  onMouseLeave={e => e.currentTarget.style.opacity = 0.75}
>
  &#8592;
</button>
  <span className="sx-registrate-label" style={{
    position: 'absolute', left: '50%',
    transform: 'translateX(-50%)', fontFamily: 'Georgia, serif',
    fontSize: '15px', letterSpacing: '0.31em',
    textTransform: 'uppercase', color: '#fff', opacity: 0.9
  }}>
    Registrate
  </span>
</header>
      <div style={{ position: 'relative', zIndex: 10, display: 'flex', flexDirection: 'column', alignItems: 'center', minHeight: '100vh', padding: '100px 48px 20px' }}>
        <div style={{ width: '100%', maxWidth: '560px', marginTop: '40px' }}>
          {enviado ? (
            <p style={{ fontFamily: 'Georgia, serif', color: '#fff', fontSize: '18px', textAlign: 'center', opacity: 0.85 ,  position: 'absolute',top: '50%',left: '50%', transform: 'translate(-50%, -50%)', width: '80%'}}>
              Gracias por registrarte, nos pondremos en contacto contigo pronto.
            </p>
          ) : (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '28px' }}>
              <div style={{ display: 'flex', gap: '24px', flexWrap: 'wrap' }}>
                <div style={{ ...fieldWrap, flex: 1, minWidth: '140px' }}>
                  <label style={labelStyle}>Nombre</label>
                  <input name="nombre" value={form.nombre} onChange={handleChange} style={inputStyle} />
                </div>
                <div style={{ ...fieldWrap, flex: 1, minWidth: '140px' }}>
                  <label style={labelStyle}>Apellidos</label>
                  <input name="apellidos" value={form.apellidos} onChange={handleChange} style={inputStyle} />
                </div>
              </div>

              <div style={fieldWrap}>
                <label style={labelStyle}>Categoría</label>
                <div style={{ display: 'flex', gap: '16px', marginTop: '8px' }}>
                  {['Nueva Aspirante', 'Candidata Recomendada', 'Ganadora de Corona'].map(op => (
                    <label key={op} style={{ fontFamily: 'Georgia, serif', fontSize: '13px', color: '#fff', display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', opacity: form.categoria === op ? 1 : 0.5 }}>
                      <input type="radio" name="categoria" value={op} checked={form.categoria === op} onChange={handleChange} style={{ accentColor: '#fff' }} />
                      {op}
                    </label>
                  ))}
                </div>
              </div>

              <div style={fieldWrap}>
                <label style={labelStyle}>Última Experiencia</label>
                <textarea name="ultimaCompetencia" value={form.ultimaCompetencia} onChange={handleChange} rows={1} style={{ ...inputStyle, resize: 'none', lineHeight: '1.6' }} />
              </div>

              <div style={{ display: 'flex', gap: '24px', flexWrap: 'wrap' }}>
                <div style={{ ...fieldWrap, flex: 1, minWidth: '140px' }}>
                  <label style={labelStyle}>Estado</label>
                  <input name="estado" value={form.estado} onChange={handleChange} style={inputStyle} />
                </div>
                <div style={{ ...fieldWrap, flex: 1, minWidth: '100px' }}>
                  <label style={labelStyle}>Edad</label>
                  <input name="edad" type="number" value={form.edad} onChange={handleChange} style={inputStyle} min="1" max="25" />
                </div>
              </div>

              <div style={fieldWrap}>
                <label style={labelStyle}>¿Por qué deseas ser Reina del Vino?</label>
                <textarea name="conocimiento" value={form.conocimiento} onChange={handleChange} rows={3} style={{ ...inputStyle, resize: 'none', lineHeight: '1.6' }} />
              </div>

              {[{ name: 'curriculum', label: 'Currículum' }, { name: 'aval', label: 'Carta de Recomendación' }, { name: 'documentacion', label: 'Documentación' }].map(f => (
                <div key={f.name} style={fieldWrap}>
                  <label style={labelStyle}>{f.label}</label>
                  <input type="file" name={f.name} onChange={handleChange} style={{ ...inputStyle, paddingTop: '8px', cursor: 'pointer' }} />
                  {form[f.name] && <span style={{ fontSize: '11px', color: 'rgba(255,255,255,0.5)', marginTop: '4px' }}>{form[f.name].name}</span>}
                </div>
              ))}

             <label className="sx-terminos-label">
             <input 
              type="checkbox" 
              name="acepta" 
              checked={form.acepta} 
             onChange={handleChange}
             className="sx-terminos-checkbox"
             />
             <span className="sx-terminos-text sx-terminos-desktop">
              Acepto sujetarme a las condiciones y reglamento de Reina del Vino
             </span>
             <span className="sx-terminos-text sx-terminos-movil">
             Acepto sujetarme a las condiciones y reglamento de RVMX
             </span>
            </label>

              <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                <button
                  onClick={handleSubmit}
                  style={{
                    fontFamily: 'Georgia, serif',
                    fontSize: '11px',
                    letterSpacing: '0.1em',
                    color: 'rgba(255,255,255,0.6)',
                    border: '1px solid rgba(255,255,255,0.15)',
                    padding: '12px',
                    background: 'rgba(255,255,255,0.03)',
                    borderRadius: '4px',
                    transition: '0.3s',
                    cursor: 'pointer',
                    width: '100%',
                    position: 'relative',
                    top: '-25px', // <--- Ajustado para que suba bien
                    zIndex: 10
                  }}
                  onMouseEnter={e => { e.currentTarget.style.color = '#fff'; e.currentTarget.style.background = 'rgba(255,255,255,0.1)'; }}
                  onMouseLeave={e => { e.currentTarget.style.color = 'rgba(255,255,255,0.6)'; e.currentTarget.style.background = 'rgba(255,255,255,0.03)'; }}
                >
                  Enviar registro
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Registrate;